import React from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

var bgimg1 = require('./../../images/background/cross-line2.png');

class Team1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            apiData: [],   // API ka data save karne ke liye
            loading: true, // loading state
            error: null    // error handle karne ke liye
        };
    }

    componentDidMount() {
        const requestOptions = {
            //  mode: 'no-cors',
            method: "GET",
            headers: {
      "Content-Type": "application/json",
    },
        };

        fetch("https://www.admin.infrioindia.com/api/v2/auth/our-teams-list", requestOptions)
            .then((response) => response.json()) // response ko JSON me convert
            .then((result) => {
                console.log("API Result:", result);
                this.setState({ apiData: result.data, loading: false });
            })
            .catch((error) => {
                console.error("API Error: Lakshay", error);
                this.setState({ error: error, loading: false });
            });
    }


    renderTeamGrid() {
         const { apiData, loading, error } = this.state;

        return (
            <div className="section-content">
                <div className="row team-item-four justify-content-center">
                    {!loading && !error && apiData.slice(0,4).map((item, index) => (
                        <div className="col-lg-3 col-md-6 col-sm-6 m-b30" key={index}>
                            <div className="our-team-2 ">
                                <div className="profile-image" style={{ width: '100%', height: '300px', overflow: 'hidden' }}>
                                    <img 
                                        src={item.icon} 
                                        alt={item.name} 
                                        style={{ 
                                            width: '100%', 
                                            height: '100%', 
                                            objectFit: 'cover',
                                            objectPosition: 'center'
                                        }} 
                                    />
                                </div>
                                <div className="figcaption text-black">
                                    <h4 className="m-t0">{item.name}</h4>
                                    <span className="m-b0">{item.designation}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        if (this.props.embedded) {
            return (
                <div className="p-t20">
                    {this.renderTeamGrid()}
                </div>
            );
        }

        return (
            <>
                <div className="section-full p-t30 mobile-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                         <div className="section-head">
                                                   <div className="sx-separator-outer separator-center">
                                                       <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                                           <h3 className="sep-line-one">Our Team</h3>
                                                       </div>
                                                   </div>
                                               </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        {this.renderTeamGrid()}
                    </div>
                </div>
            </>
        );
    }
};

export default Team1;
